import React from 'react';

const SkeletonCard = () => {
  return (
    <div className="bg-card rounded-2xl elevation-lg overflow-hidden w-full max-w-2xl mx-auto animate-pulse">
      <div className="h-48 md:h-56 lg:h-64 bg-muted" />
      <div className="p-6 md:p-8 space-y-6">
        <div className="space-y-3">
          <div className="h-8 bg-muted rounded-lg w-3/4" />
          <div className="h-4 bg-muted rounded w-full" />
          <div className="h-4 bg-muted rounded w-5/6" />
        </div>

        <div className="flex flex-wrap gap-3">
          {[1, 2, 3, 4]?.map((i) => (
            <div key={i} className="h-10 bg-muted rounded-lg w-24" />
          ))}
        </div>

        <div className="space-y-4">
          <div className="h-6 bg-muted rounded w-32" />
          <div className="h-8 bg-muted rounded w-48" />
        </div>

        <div className="space-y-3">
          <div className="h-6 bg-muted rounded w-32" />
          <div className="flex flex-wrap gap-2">
            {[1, 2, 3]?.map((i) => (
              <div key={i} className="h-8 bg-muted rounded-lg w-20" />
            ))}
          </div>
        </div>

        <div className="space-y-3">
          <div className="h-6 bg-muted rounded w-32" />
          {[1, 2, 3]?.map((i) => (
            <div key={i} className="h-4 bg-muted rounded w-full" />
          ))}
        </div>

        <div className="flex gap-4 pt-4">
          <div className="flex-1 h-14 bg-muted rounded-xl" />
          <div className="flex-1 h-14 bg-muted rounded-xl" />
        </div>
      </div>
    </div>
  );
};

export default SkeletonCard;